<template>
    <div class="setting-page-content-wrapper notification-settings">
        <div class="page-header">
            <div class="title">{{ $t('search.allNotificationSettings') }}</div>
            <div class="subtitle">{{ $t('notification.notificationSettingsDesc') }}</div>
        </div>
        <section>
            <BasicActions
                :settings="settings"
                @update="updateScopeNotificationSettings"
                :title="group.title"
                v-for="group of groups"
                :key="group.id"
                :allowed-scopes="group.allowedScopes"
            />
        </section>
    </div>
</template>
<script>
import Vue from "vue";
import BasicActions from "./BasicActions.vue";
import { ACTIVITY_API } from "../../../../../api/activity";

export default Vue.extend({
    name: "NotificationSettings",
    components: { BasicActions },
    data() {
        return {
            loading: false,
            settings: [],
            groups: [
                {
                    id: "basic",
                    title: this.$t('notification.basicActions'),
                    allowedScopes: ["chat-assign", "ticket-assign", "task-assign", "chat-close-own"],
                },
                {
                    id: "supsis-crm",
                    title: this.$t('notification.crmActions'),
                    allowedScopes: [
                        "tag-actions-to-visitor",
                        "create-ticket",
                        "note-actions-to-visitor",
                        "visitor-profile-updates",
                    ],
                },
                {
                    id: "company",
                    title: this.$t('notification.companyActions'),
                    allowedScopes: [
                        "chat-start",
                        "user-crud",
                        "department-crud",
                        "settings-crud",
                        "integration-channel-crud",
                        "login-form-crud",
                        "banned-word-crud",
                        "email-account-crud",
                        "prepared-content-crud",
                        "role-crud",
                        "tag-crud",
                        "welcome-message-crud",
                        "webhook-crud",
                        "billing-events",
                        "task-workflow-crud",
                        "task-crud",
                        "system-status",
                    ],
                },
                {
                    id: "chatbot",
                    title: this.$t('notification.chatbotActions'),
                    allowedScopes: [
                        "chatbot-story-crud",
                        "chatbot-forward-chat",
                        "chatbot-user-segment-crud",
                        "chatbot-credit-low",
                    ],
                },
                {
                    id: "whatsapp",
                    title: this.$t('notification.whatsappActions'),
                    allowedScopes: [
                        "whatsapp-credit-low",
                        "whatsapp-customer-group-crud",
                        "whatsapp-broadcast-message-crud",
                        "whatsapp-template-message-crud",
                    ],
                },
            ],
        };
    },
    mounted() {
        this.fetchSettings();
    },
    methods: {
        updateScopeNotificationSettings(item, platform, value) {
            this.settings = this.settings.map((setting) => {
                if (setting.scope === item) {
                    setting[platform] = value;
                }
                return setting;
            });
        },
        fetchSettings() {
            this.loading = true;
            ACTIVITY_API.NOTIFICATION.getMySettings()
                .then((res) => {
                    this.settings = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
});
</script>

<style scoped lang="scss">
.notification-settings {
}
</style>
